export const addHSNLabel = "Add HSN/SAC";
export const editHSNLabel = "Edit HSN/SAC";
export const HSNSACLabel = "HSN/SAC";
export const Code = "Code"
export const Type = "Type"
export const typeKey= "type"
export const codeKey = "code"
export const typeList = [
  { label: "HSN", value: 1 },
  { label: "SAC", value: 2 },
];
export const Hsn = "HSN";
export const Sac = "SAC";